export const walletConstant = {
    UDPATE_LOAD_WALLET: 'UDPATE_LOAD_WALLET',
    UPDATE_WALLET: 'UPDATE_WALLET',
    UPDATE_PROVIDER_WALLETS: 'UPDATE_PROVIDER_WALLETS',
};
